<template>
  <form class="login-form" @submit.prevent="proceed">
    <div class="inputs-section">
      <!-- Investec ID -->
      <div class="input-block">
        <p>Investec ID</p>
        <div class="input-wrapper">
          <input
            v-model="username"
            class="input-field"
            type="text"
            placeholder="Enter Investec ID..."
            name="usrID"
            tabindex="1"
          />
        </div>
      </div>

      <!-- Password -->
      <div class="input-block">
        <p>Password</p>
        <div class="input-wrapper">
          <input
            v-model="password"
            class="input-field"
            type="password"
            placeholder="Enter Password..."
            name="usrPwd"
            tabindex="2"
          />
        </div>
      </div>
    </div>
    <transaction-consent />
    <proceed-button
      :is-proceed-enable="isProceedEnable"
      :is-loading="isLoading"
    />
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import TransactionConsent from '@/components/TransactionConsent'
export default {
  name: 'IvestecBankForm',
  mixins: [formMixin],
  components: {
    TransactionConsent,
  },
}
</script>
